module.exports = __webpack_public_path__ + "static/media/logo.02aa7499.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/logo.svg
// module id = 365
// module chunks = 0